import { MspInProductTrialsOverlayWindowType } from '../../../mspInProductTrialsOverlaysApp/types/MspInProductTrialsOverlayWindowType';
import {
  MspInProductTrialsOverlayWindowButton,
  MspInProductTrialsOverlayWindowContentConfig,
} from '../../types/MspInProductTrialsOverlayWindowContentConfig';
import { BaseWebComponentTranslator } from '../../../../../../framework/BaseWebComponentTranslator';
import { ButtonColors, ButtonThemes, ButtonTypes } from '../../../../../../ui/gzButton/types';
import { MspInProductTrialsOverlayWindowEventType } from '../../events/MspInProductTrialsOverlayWindowEventType';

function getParagraph(text: string): string {
  return `<p>${text}</p>`;
}

function getMspInProductTrialsOverlayWindowContentConfig(): {
  [type in MspInProductTrialsOverlayWindowType]: MspInProductTrialsOverlayWindowContentConfig;
} {
  const translator = BaseWebComponentTranslator.getInstance();
  const imageOverlay = 'app/webcomponents/assets/images/trial/gz-overlay-header.png';

  const buttonsSettingsForMenuOverlay: {
    button1: MspInProductTrialsOverlayWindowButton;
    button2: MspInProductTrialsOverlayWindowButton;
    button3: MspInProductTrialsOverlayWindowButton;
  } = {
    button1: {
      innerText: translator.translateFn('Explore'),
      theme: ButtonThemes.DARK,
      color: ButtonColors.PRIMARY,
      type: ButtonTypes.FULL,
      event: MspInProductTrialsOverlayWindowEventType.LearnMoreMenuOverlay,
    },
    button2: {
      innerText: translator.translateFn('How to'),
      theme: ButtonThemes.DARK,
      color: ButtonColors.WHITE,
      type: ButtonTypes.OUTLINE,
      event: MspInProductTrialsOverlayWindowEventType.HowTo,
    },
    button3: {
      innerText: translator.translateFn('Dismiss'),
      theme: ButtonThemes.DARK,
      color: ButtonColors.WHITE,
      type: ButtonTypes.OUTLINE,
      event: MspInProductTrialsOverlayWindowEventType.DismissMenuOverlay,
    },
  };

  const buttonsSettingsForCompaniesOverlay: {
    button1: MspInProductTrialsOverlayWindowButton;
    button2: MspInProductTrialsOverlayWindowButton;
    button3: MspInProductTrialsOverlayWindowButton;
  } = {
    button1: {
      innerText: translator.translateFn('Learn more'),
      theme: ButtonThemes.DARK,
      color: ButtonColors.PRIMARY,
      type: ButtonTypes.FULL,
      event: MspInProductTrialsOverlayWindowEventType.LearnMoreCompaniesOverlay,
    },
    button2: {
      innerText: translator.translateFn('How to'),
      theme: ButtonThemes.DARK,
      color: ButtonColors.WHITE,
      type: ButtonTypes.OUTLINE,
      event: MspInProductTrialsOverlayWindowEventType.HowTo,
    },
    button3: {
      innerText: translator.translateFn('Dismiss'),
      theme: ButtonThemes.DARK,
      color: ButtonColors.WHITE,
      type: ButtonTypes.OUTLINE,
      event: MspInProductTrialsOverlayWindowEventType.DismissCompaniesOverlay,
    },
  };

  return {
    [MspInProductTrialsOverlayWindowType.menuOverlay]: {
      imageSrc: imageOverlay,
      title: translator.translateFn("Explore Bitdefender's MSP Features for Free"),
      text: getParagraph(
        translator.translateFn(
          "Unlock Bitdefender's advanced MSP capabilities now! Sign up your clients at no cost for our Detection and Response Product Trials and leverage up to 60 days of premium protection and round-the-clock security monitoring. Seize this perfect opportunity to ensure your customers' IT infrastructures are shielded by our awards winning technologies.",
        ),
      ),
      buttons: buttonsSettingsForMenuOverlay,
    },
    [MspInProductTrialsOverlayWindowType.companiesOverlay]: {
      imageSrc: imageOverlay,
      title: translator.translateFn('Effortless Setup, Instant Protection'),
      text: getParagraph(
        translator.translateFn(
          'Browse the list of qualified companies for the MSP Product Trials. Pick any company to experience our advanced security features, valid for up to 60 days.',
        ),
      ),
      buttons: buttonsSettingsForCompaniesOverlay,
    },
  };
}

export function getContentConfigForMspInProductTrialsOverlayWindowType(
  overlayWindowType: MspInProductTrialsOverlayWindowType
): MspInProductTrialsOverlayWindowContentConfig {
  return getMspInProductTrialsOverlayWindowContentConfig()[overlayWindowType];
}
